export default __webpack_public_path__ + "static/media/icon_materiais_gray.3067f297.svg";